import { render, staticRenderFns } from "./IconFacebookLight.vue?vue&type=template&id=1ef1c62a&"
import script from "./IconFacebookLight.vue?vue&type=script&lang=js&"
export * from "./IconFacebookLight.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports